import type { ActivityLogsListParams } from '@/types';

import { atom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';

import { createPaginationParams, createTableQueryOptions } from '@/components/table';
import { apiClient } from '@/utils/api';
import { buildApiParams } from '@/utils/helpers';

// Atom for activity logs list parameters
export const activityLogsListParamsAtom = atom<ActivityLogsListParams>({
  page: 1,
  per_page: createPaginationParams().per_page,
  filters: {}
});

// Hydration flag to delay initial query until URL/filters are synced
export const activityLogsHydratedAtom = atom<boolean>(false);

// Main activity logs query atom
export const activityLogsQueryAtom = atomWithQuery((get) => {
  const params = get(activityLogsListParamsAtom);
  const hydrated = get(activityLogsHydratedAtom);

  return createTableQueryOptions({
    queryKey: ['activity-logs', params] as const,
    queryFn: async () => {
      const apiParams = buildApiParams(
        {
          page: params.page,
          per_page: params.per_page
        },
        params.filters
      );

      const { data } = await apiClient.get<{
        success: boolean;
        message: string;
        data: any[];
        meta: {
          total: number;
          per_page: number;
          current_page: number;
          last_page: number;
        };
      }>('/activity-logs', { params: apiParams });

      return data;
    },
    enabled: hydrated
  });
});

